import { useLocales } from '@sevenrooms/locales'
import { reservationWidgetMessages } from '../../../reservationWidgetMessages'
import { TimeSlotButton, type TimeSlotButtonProps } from '../../TimeSlotButton'

export interface AlertMeButtonProps extends Omit<TimeSlotButtonProps, 'data-test'> {}

export function AlertMeButton({ width = '100%', variant, ...props }: AlertMeButtonProps) {
  const { formatMessage } = useLocales()
  return (
    <TimeSlotButton
      data-test="alert-me-button"
      icon={variant !== 'tertiary' ? 'GX-bell-ring' : undefined}
      variant={variant}
      width={width}
      {...props}
    >
      {formatMessage(reservationWidgetMessages.resWidgetPriorityAlertsSetAlertButton)}
    </TimeSlotButton>
  )
}
